<template>
  <base-modal class="profile-settings-modal"
              height="600"
              :show="show"
              @close="close">
    <div slot="header">
      {{ $t("avatarProfilePicture") }}
    </div>

    <avatar-profile-picture :childId="fromBus.childId"
                      @close="close" />
  </base-modal>
</template>

<script>
  import AvatarProfilePicture from '@/components/Child/ChildAvatarProfilePicture/ChildSettings'
  import modalMixin from '@/mixins/modalMixin'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      AvatarProfilePicture
    },

    data() {
      return {
        fromBus: {
          childId: ''
        }
      }
    },

    beforeMount() {
      this.setOpenListener('profile')
    }
  }
</script>

<style lang="scss" scoped>
  .profile-settings-modal :deep(.modal-body) {
      min-height: 400px;
  }
</style>